import { atualizarSituacaoVersao } from "login/actions";
import { exit, update } from 'platformImpl';
import { makeStyles } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import AppFooter from "shared/template/AppFooter";
import ilustracaoAtualizacaoRefresh from './assets/img/ilustracao-atualizacao-refresh.webp';

const DESCRICAO = "Atualize o aplicativo para continuar usando os serviços com segurança e facilidade."

const useStyles = makeStyles((theme) => ({
  titulo: {
    color: theme.palette.mode === 'dark' ? "#FFF" : '#333',
    fontSize: "20.16px",
    fontWeight: '600',
    margin: 'unset',
    width: "100%"
  },
  descricao: {
    fontSize: "16.8px"
  },
  imagem: {
    marginBottom: '32px'
  },
  root: {
    zIndex: "99999 !important",
    height: "100%",
    width: "100%",
    backgroundColor: theme.palette.mode === 'dark' ? '#333' : "#FFF",
    paddingBottom: '100px',
    overflow: 'auto',
    padding: '16px',
  },
  itemsGrid: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: 'fit-content',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: '25%'
    }
  },
}))

const SolicitarAtualizacao = ({ tipo }) => {

  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <div className={classes.root}>
      <div className={classes.itemsGrid}>
            <h2 className={classes.titulo}>
              Tem novidade no Meu INSS
            </h2>

            <p className={classes.descricao}>{DESCRICAO}</p>
          <img
            className={classes.imagem}
            src={ilustracaoAtualizacaoRefresh}
            alt="Pessoa segurando um smartphone com ícone de atualização na tela, representando o gesto de atualizar o aplicativo do Meu INSS."
          />
      </div>
      {tipo == 3 /* ATUALIZACAO FORCADA */ ? (
          <AppFooter
            textAlign="right"
            primaryText="Atualizar"
            primaryAction={() => update(exit)}
            secondaryText="Sair do Meu INSS"
            secondaryAction={exit}
          />
        ) : (
          <AppFooter
            textAlign="right"
            primaryText="Atualizar"
            primaryAction={() => {
              update();
              dispatch(atualizarSituacaoVersao(0));
              sessionStorage.setItem('atualizacaoInformada', true);
            }}
            secondaryText="Atualizar mais tarde"
            secondaryAction={() => {
              dispatch(atualizarSituacaoVersao(0));
              sessionStorage.setItem('atualizacaoInformada', true);
            }}
          />
        )}
    </div>
  )
}

export default SolicitarAtualizacao;